<template>
  <BlokkliProvider v-bind="blokkli">
    <Container class="mt-20 md:mt-30 lg:mt-60 xl:mt-90">
      <div class="lg:w-8/12">
        <Tag
          v-if="category"
          color="bg-white"
          :text="category.name"
          class="mb-5"
        />

        <h1
          v-if="title"
          class="text-3xl md:text-5xl mb-20 md:mb-30 font-semibold"
        >
          {{ title }}
        </h1>

        <DrupalDateTime
          v-if="created?.first"
          v-bind="created.first"
          class="font-medium"
        />

        <p v-if="lead" class="font-normal text-md md:text-lg mt-20">
          {{ lead }}
        </p>
      </div>

      <MediaImage
        v-if="image"
        v-bind="image"
        :image-style="imageStyle"
        class="mt-30 md:mt-40 lg:mt-50"
      />

      <div v-if="body" class="content" v-html="body" />
      <BlokkliField :list="paragraphs" name="field_paragraphs" />
      <Paywall
        v-if="paywall?.showPaywall && siteName === 'pharmasuisse'"
        v-bind="paywall"
      />

      <BlokkliField
        :list="paragraphsFooter"
        field-list-type="footer"
        non-empty-class="is-footer"
        name="field_paragraphs_footer"
      />
    </Container>
  </BlokkliProvider>
</template>

<script lang="ts" setup>
import { NodeArticleFragment } from '#graphql-operations'

const { name: siteName } = useCurrentSite()

const props = defineProps<{
  title?: string
  body?: string
  canEdit?: boolean
  uuid: string
  lead?: string
  created?: NodeArticleFragment['created']
  image?: NodeArticleFragment['image']
  category?: NodeArticleFragment['category']
  paragraphs?: NodeArticleFragment['paragraphs']
  paragraphsFooter?: NodeArticleFragment['paragraphsFooter']
  paywall?: NodeArticleFragment['paywall']
}>()

const blokkli = buildBlokkliProps(props, 'node', 'article')

const imageStyle = defineImageStyle({
  type: 'sizes',
  aspectRatio: 1170 / 370,
  sizes: {
    sm: 400,
    md: 728,
    lg: 984,
    xl: 1170,
  },
})
</script>
